import axios from 'axios';
import config from '../config';
import { clearAuthSession, isAuthenticated } from './authentication';

let redirecting = false;

/**
 * Drop the local session and send the user to the login page when the API
 * rejects their token (e.g. revoked because the lab account was suspended).
 */
export function handleUnauthorizedResponse() {
  if (typeof window === 'undefined' || redirecting || !isAuthenticated()) {
    return;
  }

  redirecting = true;
  clearAuthSession();
  window.location.replace('/login');
}

const isApiRequest = (input) => {
  const url = typeof input === 'string' ? input : input?.url;

  return Boolean(url && config.apiUrl && url.startsWith(config.apiUrl));
};

export function installSessionGuard() {
  if (typeof window === 'undefined' || window.__dentristSessionGuardInstalled) {
    return;
  }

  window.__dentristSessionGuardInstalled = true;

  axios.interceptors.response.use(
    (response) => response,
    (error) => {
      if (error?.response?.status === 401) {
        handleUnauthorizedResponse();
      }

      return Promise.reject(error);
    },
  );

  const originalFetch = window.fetch.bind(window);

  window.fetch = async (input, init) => {
    const response = await originalFetch(input, init);

    if (response.status === 401 && isApiRequest(input)) {
      handleUnauthorizedResponse();
    }

    return response;
  };
}
